/**
 * Vendored from AudioCN (https://github.com/audiocn/ui), hand-copied at
 * commit 42f863ec333c6912c421d1e9d6d7ce7850ce2680.
 * Source file: lib/audio/frame-loop.ts
 * License: MIT, Copyright (c) 2026 OrcDev. See components/ui/audiocn/LICENSE.md.
 * Local changes:
 *   - none beyond this header
 */
type FrameListener = (nowMs: number) => void;

const listeners = new Set<FrameListener>();
let handle: number | null = null;

const reportError = (error: unknown) => {
  queueMicrotask(() => {
    throw error;
  });
};

const tick = (nowMs: number) => {
  handle = null;
  for (const listener of listeners) {
    try {
      listener(nowMs);
    } catch (error) {
      reportError(error);
    }
  }
  if (listeners.size > 0) {
    handle = requestAnimationFrame(tick);
  }
};

/**
 * Runs `listener` on every animation frame, on one loop shared by the whole
 * page. The loop stops when nothing is subscribed, and the browser pauses it
 * while the tab is hidden. Returns an unsubscribe function.
 */
export const subscribeFrame = (listener: FrameListener): (() => void) => {
  listeners.add(listener);
  if (handle === null && typeof requestAnimationFrame === "function") {
    handle = requestAnimationFrame(tick);
  }
  return () => {
    listeners.delete(listener);
    if (listeners.size === 0 && handle !== null) {
      cancelAnimationFrame(handle);
      handle = null;
    }
  };
};
